import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFormioContext } from "@formio/react"; // Assuming you're using the Form.io context
import FormRenderer, {
  handleExternalSubmit,
} from "../../FormRenderer/FormRenderer";
import BreadCrumb from "../../ui/BreadCrumb/BreadCrumb";
import CommonCard from "../../ui/CommonCard/CommonCard";
import classes from "./CreateDocument.module.css";

const CreateDocument = () => {
  const { formId } = useParams(); // Extract form ID from URL
  const { Formio, projectUrl } = useFormioContext(); // Get Formio instance and project base URL from context
  const navigate = useNavigate();

  const [formJson, setFormJson] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("formioToken");
  Formio.setToken(token); // Ensure Formio requests are authenticated

  const fetchFunction = useCallback(() => {
    const formio = new Formio(`${projectUrl}/form/${formId}`);
    return formio.loadForm();
  }, [Formio, projectUrl, formId]);

  useEffect(() => {
    fetchFunction()
      .then((data) => {
        setFormJson(data);
        console.log("FORMS", data);
      })
      .catch((err) => {
        console.error("Failed to load form:", err);
      });
  }, [fetchFunction]);

  // const handleFormSubmit = async (submissionData) => {
  //   setLoading(true);
  //   try {
  //     const formio = new Formio(`${projectUrl}/${formJson.path}/submission`);
  //     const submission = await formio.saveSubmission({
  //       data: submissionData,
  //     });
  //     console.log("Submission successful:", submission);
  //     navigate("/");
  //   } catch (err) {
  //     setLoading(false);
  //     console.error("Submission failed:", err);
  //   }
  // };

  const handleFormSubmit = async (submissionData) => {
    setLoading(true);
    try {
      const formio = new Formio(`${projectUrl}/form/${formJson._id}`); // Correct form path
      const submission = await formio.saveSubmission({
        data: submissionData,
      });
      console.log("Submission successful:", submission);
      console.log("Owner ID:", submission.owner); // should now show user _id
      navigate("/");
    } catch (err) {
      setLoading(false);
      console.error("Submission failed:", err);
    }
  };

  return (
    <>
      <BreadCrumb
        cancelText="cancel"
        // createText={loading ? "Loading..." : "Create document"}
        // onCreate={handleExternalSubmit}
      />
      <div className={classes.wrapper}>
        <CommonCard>
          <div className="row">
            <div className="col-9">
              {error ? (
                <p style={{ color: "red" }}>{error}</p>
              ) : formJson ? (
                <FormRenderer
                  title={formJson.title || "Create Document"}
                  formJson={formJson}
                  onSubmit={handleFormSubmit}
                  isCreating={true}
                />
              ) : (
                <p>Loading form...</p>
              )}
            </div>
            {formJson && (
              <div
                className={`col-3 d-flex flex-column gap-3 ${classes.formContainer}`}
              >
                {/* <div className={classes.cardContainer}>
                <h4 className={classes.sectionTitle}>Notes</h4>
              </div> */}
                {/* <div className={classes.cardContainer}>
                  <h4 className={classes.sectionTitle}>Classification</h4>
                  <h6>Not set</h6>
                </div> */}
                <div className={classes.cardContainer}>
                  <h4 className={classes.sectionTitle}>Template used</h4>
                  <h6>{formJson?.title}</h6>
                </div>
              </div>
            )}
          </div>
        </CommonCard>
      </div>
    </>
  );
};

export default CreateDocument;
